module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"btn_sign_in":"Войти","placeholder_enter_the_password":"Введите пароль","incorrect_password":"Неверный пароль","incorrect_user_type":"Неверный тип пользователя"}}')
  delete Component.options._Ctor
}
